import React, { useEffect, useState, useLocation, useContext, useLayoutEffect } from "react";
import { Container, Col, Row, Tab, Tabs, Table } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { format, parseISO } from 'date-fns'
import './CompanyCorpaction.css'
function CompanyCorpaction(props, ref) {
    let getCoCode = props.coCode;
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [corptype, settype] = useState('Dividend');
    const [databonus, setdatabonus] = useState([]);
    const [datarights, setdatarights] = useState([]);
    const [datasplit, setdatasplit] = useState([]);
    const [nodatafounddiv, setnodatafounddiv] = useState(false);
    const [nodatafoundbonus, setnodatafoundbonus] = useState(false);
    const [nodatafoundsplit, setnodatafoundsplit] = useState(false);
    const [nodatafoundrights, setnodatafoundrights] = useState(false);

    // useEffect(() => {
    //     const getUrl = BaseURL + "CorporateAction";
    //     if (getCoCode != "") {
    //         alert(`${getUrl}/${corptype}/-/-/${getCoCode}/5`)
    //         fetch(`${getUrl}/${corptype}/-/-/${getCoCode}/5`)
    //             .then((response) => response.json())
    //             .then((data) => {

    //                 // if (corptype === "Dividend") {
    //                 //     if (data.data != null && data.data.length > 0) {
    //                 //         setData(data.data);

    //                 //     }
    //                 //     else { setData([]); setnodatafounddiv(true); }
    //                 // }

    //                 // else if (corptype === "bonus") {
    //                 //     if (data.data != null && data.data.length > 0) {
    //                 //         setdatabonus(data.data);
    //                 //     }
    //                 //     else { setdatabonus([]); setnodatafoundbonus(true); }
    //                 // }
    //                 // else if (corptype === "Rights") {

    //                 //     if (data.data != null && data.data.length > 0) {
    //                 //         setdatarights(data.data);
    //                 //     }
    //                 //     else { setdatarights([]); setnodatafoundrights(true); }

    //                 // }
    //                 // else if (corptype === "Split") {
    //                 //     if (data.data != null && data.data.length > 0) {
    //                 //         setdatasplit(data.data);
    //                 //     }
    //                 //     else { setdatasplit([]); setnodatafoundsplit(true); }
    //                 // }

    //             })
    //             .catch((error) => {
    //             });
    //     }

    // }, [props.coCode,corptype]);

    useEffect(() => {
        // getGetQuoteDetails(co_code, exchg);
        // {corptype}/{fromdate}/{Todate}/{co_code}/{top}

        const getUrl = BaseURL + "CorporateAction";
        if (getCoCode != "") {
            // alert(`${getUrl}/${corptype}/-/-/${getCoCode}/5`)
            fetch(`${getUrl}/${corptype}/-/-/${getCoCode}/5`)
                .then((response) => response.json())
                .then((data) => {

                    setData(data.data);
                    setdatabonus(data.data)
                    setdatarights(data.data)
                    setdatasplit(data.data)
                    //   console.log(data.data)
                })
                .catch((error) => {
                    setdatabonus([]); setnodatafoundbonus(true);
                    setdatarights([]); setnodatafoundrights(true);
                    //console.log("not found the api");
                });
        }


    }, [corptype, props.coCode]);

    const handleSelect = (key) => {
        if (key === "tabDividend")
            settype('Dividend');
        else if (key === "tabBonus")
            settype('bonus');
        else if (key === "tabRights")
            settype('Rights');
        else if (key === "tabSplit")
            settype('Split');
    }
    return (
        <>
            <section className="company-fundamental-section">
                <Container className="add-border table-boxCorp">
                    <Row>
                        <Col md={12}>
                            <h4>Corporate Actions</h4>
                            <Tabs
                                defaultActiveKey="tabDividend"
                                transition={true}
                                id="noanim-tab-example"
                                className="mb-3" onSelect={(e) => handleSelect(e)}>
                                <Tab eventKey="tabDividend" title="Dividend">
                                    <div className="table-responsive">
                                        <table className="table table-sm table-striped table-bordered table-hover">
                                            <thead className="heading">
                                                <tr>
                                                    <th className="textcenter">Ex Date</th>
                                                    <th>Record Date</th>
                                                    <th>Dividend Amount</th>
                                                    <th>Dividend (%)</th>
                                                    {/* <th>Remark</th> */}
                                                </tr>
                                            </thead>
                                            {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                            <tbody >
                                                {/* {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                                                {data && data.map(({ DivDate, DivAmount, DivPer, Description, RecordDate }) => (
                                                    <>
                                                        <tr className="tbldata">
                                                            <th className="textcenter">{(DivDate != null) ? (format(parseISO(DivDate), 'dd-MMM-yyyy')) : '-'}</th>
                                                            <th className="textcenter">{(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : '-'}</th>
                                                            <th>{DivAmount != null ? DivAmount.toFixed(2) : 0}</th>
                                                            <th>{DivPer != null ? DivPer.toFixed(2) : 0}</th>
                                                            {/* <th className="textcenter">{Description}</th> */}
                                                        </tr>
                                                    </>
                                                ))}
                                                {nodatafounddiv &&
                                                    <tr>
                                                        <td colSpan="5" className="textcenter nodata">No data found for Dividend !!!</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </Tab>
                                <Tab eventKey="tabBonus" title="Bonus">
                                    <div className="table-responsive">
                                        <Table striped bordered hover size="sm">
                                            <thead className="heading">
                                                <tr>

                                                    <th>Ratio</th>
                                                    <th>Record Date</th>
                                                    <th className="textcenter">Ex Date</th>

                                                </tr>
                                            </thead>
                                            <tbody >
                                                {(databonus === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                {databonus && databonus.map(({ BonusDate, RecordDate, BonusRatio }) => (
                                                    <>
                                                        <tr className="tbldata">
                                                            <th className="textcenter">{(RecordDate != null) ? (format(parseISO(RecordDate), 'dd-MMM-yyyy')) : '-'}</th>

                                                            <th className="textcenter">{BonusRatio}</th>
                                                            <th className="textcenter">{(BonusDate != null) ? (format(parseISO(BonusDate), 'dd-MMM-yyyy')) : '-'}</th>
                                                        </tr>
                                                    </>
                                                ))}
                                                {nodatafoundbonus &&
                                                    <tr>
                                                        <td colSpan="5" className="textcenter nodata">No data found for Bonus !!!</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </Tab>
                                <Tab eventKey="tabRights" title="Rights">
                                    <div className="table-responsive">
                                        <Table striped bordered hover size="sm">
                                            <thead className="heading">
                                                <tr>
                                                    <th className="textcenter">Ex Date</th>
                                                    <th>Ratio</th>
                                                    <th>Record Date</th>
                                                    <th>Offer Price</th>
                                                </tr>
                                            </thead>

                                            <tbody >
                                                {(datarights === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                {datarights && datarights.map(({ RightDate, recorddate, RightsRatio, premium }) => (
                                                    <>
                                                        <tr className="tbldata">
                                                            <th className="textcenter">{(RightDate != null) ? (format(parseISO(RightDate), 'dd-MMM-yyyy')) : '-'}</th>
                                                            <th className="textcenter">{RightsRatio}</th>
                                                            <th className="textcenter">{(recorddate != null) ? (format(parseISO(recorddate), 'dd-MMM-yyyy')) : '-'}</th>
                                                            <th className="textcenter">{premium}</th>
                                                        </tr>
                                                    </>
                                                ))}
                                                {nodatafoundrights &&
                                                    <tr>
                                                        <td colSpan="5" className="textcenter nodata">No data found for Rights !!!</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </Tab>
                                <Tab eventKey="tabSplit" title="Split">
                                    <div className="table-responsive">
                                        <Table striped bordered hover size="sm">
                                            <thead className="heading">
                                                <tr>
                                                    <th className="textcenter">Ex Date</th>
                                                    <th>Record Date</th>
                                                    <th>Face Value Before</th>
                                                    <th>Face Value After</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(datasplit === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                                                {datasplit && datasplit.map(({ SplitDate, recorddate, FVBefore, FVAfter }) => (
                                                    <>
                                                        <tr className="tbldata">
                                                            <th className="textcenter">{(SplitDate != null) ? (format(parseISO(SplitDate), 'dd-MMM-yyyy')) : '-'}</th>
                                                            {/* <th className="textcenter">{format(parseISO(recorddate), 'dd-MMM-yyyy')}</th> */}
                                                            <th className="textcenter">{recorddate != null ? format(parseISO(recorddate), 'dd-MMM-yyyy') : "-"}</th>
                                                            <th className="textcenter">{FVBefore}</th>
                                                            <th className="textcenter">{FVAfter}</th>

                                                        </tr>
                                                    </>
                                                ))}
                                                {nodatafoundsplit &&
                                                    <tr>
                                                        <td colSpan="5" className="textcenter nodata">No data found for Split !!!</td>
                                                    </tr>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </Tab>
                            </Tabs>

                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default CompanyCorpaction;